import { SUB_SESSION_STORAGE_KEY } from './wireContract';

export type SubSessionStorage = Pick<Storage, 'getItem' | 'removeItem' | 'setItem'>;

// Merely reading `window.sessionStorage` throws in some privacy setups, so this is the
// feature detection too.
export const getSessionStorage = (): SubSessionStorage | null => {
  try {
    const storage = window.sessionStorage;
    storage.getItem(SUB_SESSION_STORAGE_KEY);
    return storage;
  } catch {
    return null;
  }
};

// Private mode and blocked storage throw on access; the tab then gets a new sub-session
// for every document.
export const readSubSessionId = (storage: SubSessionStorage): string | null => {
  try {
    return storage.getItem(SUB_SESSION_STORAGE_KEY);
  } catch {
    return null;
  }
};

export const writeSubSessionId = (storage: SubSessionStorage, subSessionId: string): void => {
  try {
    storage.setItem(SUB_SESSION_STORAGE_KEY, subSessionId);
  } catch {
    // Best effort.
  }
};

export const clearSubSessionId = (storage: SubSessionStorage): void => {
  try {
    storage.removeItem(SUB_SESSION_STORAGE_KEY);
  } catch {
    // Best effort.
  }
};
